/**
 * 入库签收权限相关字段，来自
 * https://liaofeng.feishu.cn/sheets/shtcnZwEnu3NxrS22N9Onqwtuzb?sheet=a1f812
 */

/**
 * 入库签收
 */
export const Read = 'wms_inbound_sign_read';
